import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/api';

const Navbar: React.FC = () => {
  const { user, logout, apiKey, updateApiKey } = useAuth();
  const navigate = useNavigate();
  const [showApiKey, setShowApiKey] = useState(false);
  const [isRegeneratingKey, setIsRegeneratingKey] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const regenerateApiKey = async () => {
    setIsRegeneratingKey(true);
    try {
      const response = await authService.regenerateApiKey();
      updateApiKey(response.apiKey);
      alert('API key başarıyla yenilendi!');
    } catch (error) {
      alert('API key yenilenirken hata oluştu');
    } finally {
      setIsRegeneratingKey(false);
    }
  };

  const copyApiKey = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      alert('API key kopyalandı!');
    }
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/dashboard" className="flex-shrink-0">
              <h1 className="text-xl font-bold text-gray-900">Postify</h1>
            </Link>
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <Link
                to="/dashboard"
                className="text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
              >
                Dashboard
              </Link>
              <Link
                to="/editor"
                className="text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
              >
                Yeni Template
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="relative">
              <button
                onClick={() => setShowApiKey(!showApiKey)}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                API Key
              </button>
              {showApiKey && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg py-1 z-10 border">
                  <div className="px-4 py-2">
                    <p className="text-xs text-gray-500 mb-2">API Key:</p>
                    <div className="flex items-center space-x-2">
                      <input
                        type="text"
                        value={apiKey || ''}
                        readOnly
                        className="flex-1 text-xs font-mono bg-gray-50 border rounded px-2 py-1"
                      />
                      <button
                        onClick={copyApiKey}
                        className="text-xs bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
                      >
                        Kopyala
                      </button>
                    </div>
                    <button
                      onClick={regenerateApiKey}
                      disabled={isRegeneratingKey}
                      className="mt-2 text-xs bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 disabled:opacity-50"
                    >
                      {isRegeneratingKey ? 'Yenileniyor...' : 'Yenile'}
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-700">{user?.email}</span>
              <button
                onClick={handleLogout}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Çıkış
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
